/**
 * Dati legali e societari · GoStreet
 * Centralizzati per facilità di aggiornamento.
 * Per modifiche puntuali contattare l'amministratore o aggiornare via SuperAdmin.
 */

export const COMPANY = {
  legal_name: "TotalKlick S.r.l.s.",
  brand: "GoStreet",
  legal_address: {
    street: "Corso Alessandro Volta, 26",
    cap: "80040",
    city: "Terzigno",
    province: "NA",
    country: "Italia",
    full: "Corso Alessandro Volta, 26 — 80040 Terzigno (NA), Italia",
  },
  shipping_address: "Via Dante Alighieri, 5B — 84013 Cava de'Tirreni (SA)",
  vat_number: "10559691216",
  fiscal_code: "10559691216",
  rea_number: "[NA - da aggiornare]",
  share_capital: "[da aggiornare]",
  legal_representative: "[Amministratore Unico — da aggiornare]",
  pec: "totalklicksrls24@pec.it",
  // Email societarie (TotalKlick)
  email: "info@totalklick.it",
  privacy_email: "privacy@totalklick.it",
  support_email: "support@totalklick.it",
  legal_email: "legal@totalklick.it",
  admin_email: "admin@totalklick.it",
  // Email prodotto (GoStreet)
  sender_email: "noreply@gostreet.it",
  team_email: "team@gostreet.it",
  // Recapiti
  phone: "+39 338 7184619",
  // Domini
  domain: "gostreet.it",
  app_url: "https://gostreet.it",
  company_domain: "totalklick.it",
  company_url: "https://totalklick.it",
  bank: "Banca Sella di Cava de' Tirreni",
  unique_code: "KRRH6B9",
};

export const LAST_UPDATED = "8 giugno 2026";
